import { notification } from 'antd';
import dayjs from 'dayjs';
import { router } from '@/router/Router';
import { DATE_TIME_FORMAT } from '@/std/const/date';
import { type TokenResponse, validateToken } from '@/std/token';
import { getLogin } from '.';
import { apiLoginRenovarToken } from '../api/apiLoginRenovarToken';
import { resetLoginStore, useLoginStore } from '../store';

async function renovarToken(): Promise<boolean> {
    const { renovandoToken } = useLoginStore.getState();
    if (renovandoToken) {
        return false;
    }

    useLoginStore.setState({ renovandoToken: true });

    try {
        const response = await apiLoginRenovarToken();

        useLoginStore.setState((s) => ({
            login: s.login
                ? { ...s.login, token: response.token, token_exp: response.token_exp }
                : null,
            renovandoToken: false,
        }));

        window.location.reload();
        return true;
    } catch (e) {
        notification.error({
            description: e.message,
            title: 'Falha ao renovar token',
        });

        resetLoginStore();

        void router.navigate({ to: '/auth/login' });
        return false;
    }
}

function getTokenStatus(): 'valid' | 'about-to-expire' | 'expired' {
    const token_exp = getLogin()?.token_exp;
    if (!token_exp) {
        return 'expired';
    }

    const now = dayjs();
    const tokenExp = dayjs(token_exp, DATE_TIME_FORMAT);

    if (!tokenExp.isValid()) {
        return 'expired';
    }

    const diff = tokenExp.diff(now, 'minutes');

    if (diff <= 0) {
        return 'expired';
    }

    // Faltando 5 horas renovar o token
    if (diff <= 5 * 60) {
        return 'about-to-expire';
    }

    return 'valid';
}

export async function userNeedToLogin(): Promise<boolean> {
    const { login, empresaIdpk } = useLoginStore.getState();
    const isUserLogged = !!login && !!empresaIdpk;

    if (!isUserLogged) {
        return true;
    }

    const tokenStatus = getTokenStatus();

    if (tokenStatus === 'expired') {
        return true;
    }

    if (tokenStatus === 'about-to-expire') {
        return !(await renovarToken());
    }

    return false;
}

export function isTokenValid(): TokenResponse {
    const login = getLogin();
    const token = login?.token;
    const tokenExp = login?.token_exp;
    return validateToken(token, tokenExp);
}
